
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'IssueDescription',
  props: {
    description: {
      type: String,
      required: true
    },
    newVariant: {
      type: Boolean,
      default: false
    },
    lineClampClass: {
      type: String,
      default: ''
    },
    shouldEmitHeightOnMount: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    emitHeight() {
      if (this.shouldEmitHeightOnMount && process.client) {
        const descriptionElement = this.$refs.descriptionContent as HTMLElement
        if (descriptionElement) {
          this.$emit('description-height', {
            scrollHeight: descriptionElement.scrollHeight,
            clientHeight: descriptionElement.clientHeight
          })
        }
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.emitHeight()
    })
  },
  watch: {
    description() {
      this.$nextTick(() => {
        this.emitHeight()
      })
    }
  }
})
